import React from "react"
import { Box, Container, Grid, List, ListItem, ListItemText } from "@mui/material"

import SEO from "@secureo/common/components/SEO"
import BreadCrumbs, { BreadCrumb } from "components/BreadCrumbs"

import { helpCenterAncestorBreadCrumbs } from "./index"
import { fallBackPhoneNumber, phoneNumbers } from "config/contact"

import { CustomAppProps } from "pages/_app"

const overviewLinks = [
	{
		title: "Rechtliche Hinweise zur Website",
		anchorLink: "#rechtliche-hinweise-zur-website",
	},
	{
		title: "Alternative Streitbeilegung",
		anchorLink: "#alternative-streitbeilegung",
	},
	{
		title: "Anonyme Datenerhebung",
		anchorLink: "#anonyme-datenerhebung",
	},
	{
		title: "Nutzung des Kontaktformulars",
		anchorLink: "#erhebung-und-verarbeitung-bei-nutzung-des-kontaktformulars",
	},
	{
		title: "Datenerhebung bei Verfassung eines Kommentars",
		anchorLink: "#datenerhebung-bei-verfassung-eines-kommentars",
	},
	{
		title: "Nutzung personenbezogener Daten",
		anchorLink: "#erhebung-verarbeitung-und-nutzung-personenbezogener-daten",
	},
	{
		title: "Newsletter",
		anchorLink: "#verwendung-der-email-adresse-fuer-die-zusendung-von-newslettern",
	},
	{
		title: "Weitergabe personenbezogener Daten",
		anchorLink: "#weitergabe-personenbezogener-daten",
	},
	{
		title: "Cookies",
		anchorLink: "#cookies",
	},
	{
		title: "Verwendung der Remarketing Funktion der Google Inc",
		anchorLink: "#verwendung-der-remarketing-funktion",
	},
	{
		title: "Verwendung von Google Adwords Conversion-Tracking",
		anchorLink: "#verwendung-von-google-adwords",
	},
	{
		title: "Nutzung von Google Analytics",
		anchorLink: "#nutzung-von-gooogle-analytics",
	},
	{
		title: "Hotjar",
		anchorLink: "#hotjar",
	},
	{
		title: "Google Display",
		anchorLink: "#google-display",
	},
	{
		title: "Verwendung von Facebook Plugins",
		anchorLink: "#verwendung-von-facebook-plugins",
	},
	{
		title: "Löschung von Daten",
		anchorLink: "#auskunft-berichtung-sperrung-und-loeschung-von-daten",
	},
	{
		title: "Trusted Shop Trustbadge",
		anchorLink: "#einbindung-des-trusted-shops-trustbadge",
	},
]

const ImprintPage = ({ asPath, locale }: CustomAppProps) => {
	const currentPath: BreadCrumb = {
		href: "/help/imprint",
		label: "Impressum",
	}

	return (
		<>
			<SEO
				asPath={asPath}
				appendLocalizedShopNameWithPipe
				title="Impressum &amp; Datenschutz"
			/>
			<div style={{ position: "relative", overflow: "hidden" }}>
				<img
					alt="background"
					src="https://res.cloudinary.com/digitalzylinder-shop/image/upload/v1590648703/DigiShop2/Content/Imprint-Bg-Circle.png"
					style={{
						position: "absolute",
						width: "100%",
						height: 500,
						top: 0,
						left: 0,
						zIndex: -1,
					}}
				/>
				<BreadCrumbs
					locale={locale}
					currentPath={currentPath}
					ancestors={helpCenterAncestorBreadCrumbs}
				/>
				<Box my={5}>
					<Container>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<div>
									<div
										style={{
											color: "#4691CE",
											textTransform: "uppercase",
											fontSize: 13,
										}}
									>
										<strong>Warum mit uns?</strong>
									</div>
									<Box mb={2}>
										<h1 style={{ margin: 0, fontSize: 30 }}>
											Impressum &amp; Datenschutzerklärung
										</h1>
									</Box>
								</div>
							</Grid>
							<Grid item xs={12} md={6}>
								<img
									alt="buero"
									src="https://res.cloudinary.com/digitalzylinder-shop/image/upload/v1590590119/DigiShop2/Content/Hintergrund-Buero.png"
									style={{
										height: 380,
										width: "100%",
										objectFit: "cover",
										borderRadius: 10,
									}}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<Box mb={5} style={{ color: "#505e5f" }}>
									<h2>Impressum</h2>
									<div>Gesetzliche Anerkennung:</div>
									<div>
										<strong>Secureo GmbH</strong>
									</div>
									<div>
										diese vertreten durch die Geschäftsführerin Caroline
										Reinalter
									</div>
									<div>Im Moos 19</div>
									<div>6067 Absam</div>
									<div>Österreich</div>
									<div>
										<strong>Telefon:</strong> {fallBackPhoneNumber}
									</div>
									<div>
										<strong>Telefon Österreich:</strong> {phoneNumbers.AT}
									</div>
									<div>
										<strong>Telefon Deutschland:</strong> {phoneNumbers.DE}
									</div>
									<div>
										<strong>E-Mail:</strong> office@secureo.at
									</div>
									<Box mt={2}>
										<strong>USt-IdNr. Österreich:</strong> ATU68967825
									</Box>
									<div>
										<strong>USt-IdNr. Deutschland:</strong> DE297458371
									</div>
									<div>
										<strong>Firmenbuch-Gericht:</strong> Landesgericht Innsbruck
									</div>
									<div>
										<strong>Firmenbuchnummer:</strong> 422359t
									</div>
									<div>Mitgliedschaften: WKO, Händlerbund</div>
									<div>
										Gesetzliche Vorschriften: Unternehmensgesetzbuch /
										GmbH-Gesetz:
									</div>
									<div>
										GmbH-Gesetz:{" "}
										<a
											href="www.ris.bka.gv.at"
											target="_blank"
											rel="noopener noreferrer"
										>
											www.ris.bka.gv.at
										</a>
									</div>
								</Box>
							</Grid>
						</Grid>
						{/* Grey Box */}
						<Box
							mb={5}
							style={{
								background: "whitesmoke",
								textAlign: "center",
								padding: 20,
								maxWidth: 800,
								margin: "auto",
							}}
						>
							<Box my={5}>
								<p>
									Die europäische Online-Streitbeilegungsplattform
									(&quot;OS-Plattform&quot;) wird nach Bereitstellung durch die
									EU-Kommission über das Portal &quot;Ihr Europa&quot;
									tiny.cc/0v8tuy zugänglich sein.
								</p>
							</Box>
							<Box my={5}>
								<div>
									<strong>
										Wir sind Mitglied der Initiative &quot;FairCommerce&quot;.
									</strong>
								</div>
								Nähere Informationen hierzu finden Sie unter{" "}
								<a
									href="https://www.fair-commerce.de"
									target="_blank"
									rel="noopener noreferrer"
								>
									www.fair-commerce.de
								</a>
								.
							</Box>
						</Box>
						<Box my={5}>
							<Grid container spacing={3}>
								<Grid item xs={12} md={3}>
									<List component="nav" aria-label="overview-imprint">
										<ListItem>
											<div className="h2" style={{ fontSize: 26 }}>
												Übersicht
											</div>
										</ListItem>
										{overviewLinks.map((overviewLink) => {
											const { title, anchorLink } = overviewLink
											return (
												<a href={anchorLink} key={title}>
													<ListItem
														button
														style={{ padding: 0, paddingLeft: 15 }}
													>
														<ListItemText
															primary={title}
															style={{ color: "#505e5f" }}
														/>
													</ListItem>
												</a>
											)
										})}
									</List>
								</Grid>
								<Grid item xs={12} md={9}>
									<Box my={5}>
										<Box mb={3} id="rechtliche-hinweise-zur-website">
											<strong>Rechtliche Hinweise zur Webseite</strong>
										</Box>
										<p>
											Alle Texte, Bilder und weiter hier veröffentlichten
											Informationen unterliegen dem Urheberrecht des
											Anbieters, soweit nicht Urheberrechte Dritter bestehen.
											In jedem Fall ist eine Vervielfältigung, Verbreitung
											oder öffentliche Wiedergabe ausschließlich im Falle
											einer widerruflichen und nicht übertragbaren Zustimmung
											des Anbieters gestattet.
										</p>
										<p>
											Für alle mittels Querverweis (Link) verbundenen
											Webinhalte übernimmt der Anbieter keine Verantwortung,
											da es sich hierbei nicht um eigene Inhalte handelt. Die
											verlinkten Seiten wurden auf rechtswidrige Inhalte
											überprüft, zum Zeitpunkt der Verlinkung waren solche
											nicht erkennbar. Verantwortlich für den Inhalt der
											verlinkten Seiten ist deren Betreiber. Der Anbieter hat
											hierzu keine allgemeine Überwachungs- und
											Prüfungspflicht. Bei Bekanntwerden einer
											Rechtsverletzung wird der entsprechende Link jedoch
											umgehend entfernt.
										</p>
										<Box my={3} id="alternative-streitbeilegung">
											<strong>
												Alternative Streitbeilegung gemäß Art. 14 Abs. 1
												ODR-VO und ß 36 VSBG:
											</strong>
										</Box>
										<p>
											Die Europäische Kommission stellt eine Plattform zur
											Online-Streitbeilegung (OS) bereit, die Sie unter
											http://ec.europa.eu/consumers/odr/ finden. Verbraucher
											haben die Möglichkeit, sich für die Beilegung ihrer
											Streitigkeiten an [Name, Anschrift, Webseite der
											Schlichtungsstelle] zu wenden. Wir sind bereit, an
											Verfahren zur Streitbeilegung vor dieser Stelle
											teilzunehmen. Wir werden an einem solchen Verfahren
											teilnehmen.
										</p>
									</Box>
									<Box pt={5} my={5}>
										<Box mb={3}>
											<h2>Datenschutzerklärung</h2>
										</Box>
										<p>
											Wir legen größten Wert auf den Schutz Ihrer Daten und
											die Wahrung Ihrer Privatsphäre. Nachstehend informieren
											wir Sie deshalb über die Erhebung und Verwendung
											persönlicher Daten bei Nutzung unserer Webseite.
										</p>
										<Box my={3} id="anonyme-datenerhebung">
											<strong>Anonyme Datenerhebung</strong>
										</Box>
										<p>
											Sie können unsere Webseiten besuchen, ohne Angaben zu
											Ihrer Person zu machen. Wir speichern in diesem
											Zusammenhang keinerlei persönliche Daten. Um unser
											Angebot zu verbessern, werten wir lediglich statistische
											Daten aus, die keinen Rückschluss auf Ihre Person
											erlauben.
										</p>
										<Box
											my={3}
											id="erhebung-und-verarbeitung-bei-nutzung-des-kontaktformulars"
										>
											<strong>
												Erhebung und Verarbeitung bei Nutzung des
												Kontaktformulars
											</strong>
										</Box>
										<p>
											Bei Nutzung des Kontaktformulars erheben wir
											personenbezogene Daten (Einzelangaben über persönliche
											oder sachliche Verhältnisse einer bestimmten oder
											bestimmbaren natürlichen Person) nur in dem von Ihnen
											zur Verfügung gestellten Umfang. Ihre E-Mail-Adresse
											nutzen wir nur zur Bearbeitung Ihrer Anfrage. Ihre Daten
											werden anschließend gelöscht, sofern Sie der
											weitergehenden Verarbeitung und Nutzung nicht zugestimmt
											haben.
										</p>
										<Box
											my={3}
											id="datenerhebung-bei-verfassung-eines-kommentars"
										>
											<strong>
												Datenerhebung bei Verfassung eines Kommentars
											</strong>
										</Box>
										<p>
											Wir erheben personenbezogene Daten im Rahmen Ihrer
											Kommentierung zu einem Artikel oder Beitrag nur in dem
											Umfang, wie sie von Ihnen mitgeteilt werden.
										</p>
										<Box
											my={3}
											id="erhebung-verarbeitung-und-nutzung-personenbezogener-daten"
										>
											<strong>
												Erhebung, Verarbeitung und Nutzung personenbezogener
												Daten
											</strong>
										</Box>
										<p>
											Wir erheben personenbezogene Daten (Einzelangaben über
											persönliche oder sachliche Verhältnisse einer bestimmten
											oder bestimmbaren natürlichen Person) nur in dem von
											Ihnen zur Verfügung gestellten Umfang. Die Verarbeitung
											und Nutzung Ihrer personenbezogenen Daten erfolgt zur
											Erfüllung und Abwicklung Ihrer Bestellung sowie zur
											Bearbeitung Ihrer Anfragen. Nach vollständiger
											Vertragsabwicklung werden alle personenbezogenen Daten
											zunächst unter Berücksichtigung steuer- und
											handelsrechtlicher Aufbewahrungsfristen gespeichert und
											dann nach Fristablauf gelöscht, sofern Sie der
											weitergehenden Verarbeitung und Nutzung nicht zugestimmt
											haben.
										</p>
										<Box
											my={3}
											id="verwendung-der-email-adresse-fuer-die-zusendung-von-newslettern"
										>
											<strong>
												Verwendung der E-Mail-Adresse für die Zusendung von
												Newslettern
											</strong>
										</Box>
										<p>
											Wir nutzen Ihre E-Mail-Adresse unabhängig von der
											Vertragsabwicklung ausschließlich für eigene Werbezwecke
											zum Newsletterversand, sofern Sie dem ausdrücklich
											zugestimmt haben. Ihre diesbezüglich abzugebende
											Einwilligungserklärung lautet wie folgt:
										</p>
										<p>&quot;Newsletter abonnieren&quot;</p>

										<p>
											Sie können den Newsletter jederzeit unter Nutzung des
											entsprechenden Link im Newsletter oder durch Nachricht
											an uns abbestellen, die Kontaktdaten hierzu finden Sie
											in unserem Impressum. Ihre E-Mail-Adresse wird danach
											aus dem Verteiler gelöscht.
										</p>
										<Box my={3} id="weitergabe-personenbezogener-daten">
											<strong>Weitergabe personenbezogener Daten</strong>
										</Box>
										<p>
											Eine Weitergabe Ihrer Daten an Dritte ohne Ihre
											ausdrückliche Einwilligung erfolgt nicht. Ausgenommen
											hiervon sind lediglich unsere Dienstleistungspartner,
											die wir zur Abwicklung des Vertragsverhältnisses
											benötigen. In diesen Fällen beachten wir strikt die
											Vorgaben des Bundesdatenschutzgesetzes. Der Umfang der
											Datenübermittlung beschränkt sich auf ein Mindestmaß.
										</p>
										<Box my={3} id="cookies">
											<strong>Cookies</strong>
										</Box>
										<p>
											Unsere Internetseiten verwenden an mehreren Stellen so
											genannte Cookies. Cookies sind kleine Textdateien, die
											auf Ihrem Rechner abgelegt werden und die Ihr Browser
											speichert. Sie dienen dazu, unser Angebot
											nutzerfreundlicher, effektiver und sicherer zu machen.
											Des Weiteren ermöglichen Cookies unseren Systemen, Ihren
											Browser zu erkennen und Ihnen Services anzubieten.
											Cookies enthalten keine personenbezogenen Daten.
										</p>
										<Box my={3} id="verwendung-der-remarketing-funktion">
											<strong>
												Verwendung der Remarketing- oder &quot;Ähnliche
												Zielgruppen&quot;-Funktion der Google Inc.
											</strong>
										</Box>
										<p>
											Der Anbieter verwendet auf der Webseite die Remarketing-
											oder &quot;Ähnliche Zielgruppen&quot;- Funktion der
											Google Inc. („Google“). Mittels dieser Funktion kann der
											Anbieter die Besucher der Webseite zielgerichtet mit
											Werbung ansprechen, indem für Besucher der Webseite des
											Anbieters personalisierte, interessenbezogene
											Werbung-Anzeigen geschaltet werden, wenn sie andere
											Webseiten im Google Display-Netzwerk besuchen. Zur
											Durchführung der Analyse der Webseiten- Nutzung, welche
											die Grundlage für die Erstellung der interessenbezogenen
											Werbeanzeigen bildet, setzt Google sog. Cookies ein.
											Hierzu speichert Google eine kleine Datei mit einer
											Zahlenfolge in den Browsern der Besucher der Webseite.
											Über diese Zahl werden die Besuche der Webseite sowie
											anonymisierte Daten über die Nutzung der Webseite
											erfasst. Es erfolgt keine Speicherung von
											personenbezogenen Daten der Besucher der Webseite.
											Besuchen Sie nachfolgend eine andere Webseite im Google
											Display-Netzwerk werden Ihnen Werbeeinblendungen
											angezeigt, die mit hoher Wahrscheinlichkeit zuvor
											aufgerufene Produkt- und Informationsbereiche
											berücksichtigen. <br />
											Sie können die Verwendung von Cookies durch Google
											dauerhaft deaktivieren, indem Sie dem nachfolgenden Link
											folgen und das dort bereitgestellte Plug-In
											herunterladen und installieren: <br />
											<a
												href="https://www.google.com/settings/ads/plugin?hl=de"
												target="_blank"
												rel="noopener noreferrer"
											>
												https://www.google.com/settings/ads/plugin?hl=de
											</a>
										</p>
										<p>
											Alternativ können Sie die Verwendung von Cookies durch
											Drittanbieter deaktivieren, indem sie die
											Deaktivierungsseite der Netzwerkwerbeinitiative (Network
											Advertising Initiative) unter{" "}
											<a
												href="http://www.networkadvertising.org/choices/"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.networkadvertising.org/choices/
											</a>{" "}
											aufrufen und die dort genannten weiterführenden
											Information zum Opt-Out umsetzen. Weiterführende
											Informationen zu Google Remarketing sowie die
											Datenschutzerklärung von Google können Sie einsehen
											unter:
											<a
												href="http://www.google.com/privacy/ads/"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.google.com/privacy/ads/
											</a>
										</p>
										<Box my={3} id="verwendung-von-google-adwords">
											<strong>
												Verwendung von Google Adwords Conversion-Tracking
											</strong>
										</Box>
										<p>
											Wir nutzen das Online-Werbeprogramm „Google AdWords“ und
											im Rahmen von Google AdWords das Conversion-Tracking.
											Das Google Conversion Tracking ist ein Analysedienst der
											Google Inc. (1600 Amphitheatre Parkway, Mountain View,
											CA 94043, USA; „Google“). Wenn Sie auf eine von Google
											geschaltete Anzeige klicken, wird ein Cookie für das
											Conversion-Tracking auf Ihrem Rechner abgelegt. Diese
											Cookies haben eine begrenzte Gültigkeit, enthalten keine
											personenbezogenen Daten und dienen somit nicht der
											persönlichen Identifizierung. Wenn Sie bestimmte
											Internetseiten unserer Website besuchen und das Cookie
											noch nicht abgelaufen ist, können Google und wir
											erkennen, dass Sie auf die Anzeige geklickt haben und zu
											dieser Seite weitergeleitet wurden. Jeder Google
											AdWords-Kunde erhält ein anderes Cookie. Somit besteht
											keine Möglichkeit, dass Cookies über die Websites von
											AdWords-Kunden nachverfolgt werden können. Die
											Informationen, die mit Hilfe des Conversion-Cookie
											eingeholt werden, dienen dazu, Conversion-Statistiken
											für AdWords-Kunden zu erstellen, die sich für
											Conversion-Tracking entschieden haben. Hierbei erfahren
											die Kunden die Gesamtanzahl der Nutzer, die auf ihre
											Anzeige geklickt haben und zu einer mit einem
											Conversion-Tracking-Tag versehenen Seite weitergeleitet
											wurden. Sie erhalten jedoch keine Informationen, mit
											denen sich Nutzer persönlich identifizieren lassen. Wenn
											Sie nicht am Tracking teilnehmen möchten, können Sie
											dieser Nutzung widersprechen, indem Sie die Installation
											der Cookies durch eine entsprechende Einstellung Ihrer
											Browser Software verhindern (Deaktivierungsmöglichkeit).
											Sie werden sodann nicht in die Conversion-Tracking
											Statistiken aufgenommen. Weiterführende Informationen
											sowie die Datenschutzerklärung von Google finden Sie
											unter:{" "}
											<a
												href="http://www.google.de/policies/privacy/"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.google.de/policies/privacy/
											</a>
										</p>
										<Box my={3} id="nutzung-von-gooogle-analytics">
											<strong>Nutzung von Google Analytics</strong>
										</Box>
										<p>
											Diese Website benutzt Google Analytics, einen
											Webanalysedienst der Google Inc. („Google“). Google
											Analytics verwendet sog. „Cookies“, Textdateien, die auf
											Ihrem Computer gespeichert werden und die eine Analyse
											der Benutzung der Website durch Sie ermöglichen. Die
											durch den Cookie erzeugten Informationen über Ihre
											Benutzung dieser Website werden in der Regel an einen
											Server von Google in den USA übertragen und dort
											gespeichert. Im Falle der Aktivierung der
											IP-Anonymisierung auf dieser Webseite, wird Ihre
											IP-Adresse von Google jedoch innerhalb von
											Mitgliedstaaten der Europäischen Union oder in anderen
											Vertragsstaaten des Abkommens über den Europäischen
											Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen
											wird die volle IP-Adresse an einen Server von Google in
											den USA übertragen und dort gekürzt. Im Auftrag des
											Betreibers dieser Website wird Google diese
											Informationen benutzen, um Ihre Nutzung der Website
											auszuwerten, um Reports über die Websiteaktivitäten
											zusammenzustellen und um weitere mit der Websitenutzung
											und der Internetnutzung verbundene Dienstleistungen
											gegenüber dem Websitebetreiber zu erbringen. Die im
											Rahmen von Google Analytics von Ihrem Browser
											übermittelte IP-Adresse wird nicht mit anderen Daten von
											Google zusammengeführt. Sie können die Speicherung der
											Cookies durch eine entsprechende Einstellung Ihrer
											Browser-Software verhindern; wir weisen Sie jedoch
											darauf hin, dass Sie in diesem Fall gegebenenfalls nicht
											sämtliche Funktionen dieser Website vollumfänglich
											werden nutzen können. Sie können darüber hinaus die
											Erfassung der durch das Cookie erzeugten und auf Ihre
											Nutzung der Website bezogenen Daten (inkl. Ihrer
											IP-Adresse) an Google sowie die Verarbeitung dieser
											Daten durch Google verhindern, indem sie das unter dem
											folgenden Link verfügbare Browser-Plugin herunterladen
											und installieren{" "}
											<a
												href="http://tools.google.com/dlpage/gaoptout?hl=de"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://tools.google.com/dlpage/gaoptout?hl=de
											</a>
											.
										</p>
										<Box my={3} id="hotjar">
											<strong>Hotjar</strong>
										</Box>
										<p>
											Für die Verbesserung der Nutzererfahrung auf unseren
											Internetseiten setzen wir die Software Hotjar{" "}
											<a
												href="http://www.hotjar.com"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.hotjar.com
											</a>{" "}
											ein. Mittels Hotjar können wir das Nutzerverhalten
											(Mausbewegungen, Klicks, Scrollhöhe etc.) auf unseren
											Internetseiten messen und auswerten. Zu diesem Zweck
											setzt Hotjar Cookies auf Endgeräten der Nutzer und kann
											Daten von Nutzern wie z. B. Browser Informationen,
											Betriebssystem, Verweildauer auf der Seite etc. in
											anonymisierter Form speichern. Sie können diese
											Datenverarbeitung durch Hotjar verhindern, indem Sie in
											den Einstellungen Ihres Webbrowsers die Verwendung von
											Cookies deaktivieren und bereits aktive Cookies löschen.
											Sie können der Nutzung auf folgender Seite
											widersprechen:{" "}
											<a
												href="https://www.hotjar.com/opt-out"
												target="_blank"
												rel="noopener noreferrer"
											>
												https://www.hotjar.com/opt-out
											</a>
										</p>
										<Box my={3} id="google-display">
											<strong>Google Display</strong>
										</Box>
										<p>
											Wir verwenden auf unseren Internetseiten die
											Remarketing- oder &quot;Ähnliche Zielgruppen&quot;-
											Funktion der Google Inc. („Google“). Mittels dieser
											Funktion kann der Anbieter die Besucher der Webseite
											zielgerichtet mit Werbung ansprechen, indem für Besucher
											der Webseite des Anbieters personalisierte,
											interessenbezogene Werbung-Anzeigen geschaltet werden,
											wenn sie andere Webseiten im Google Dis-play-Netzwerk
											besuchen. Zur Durchführung der Analyse der Webseiten-
											Nutzung, welche die Grundlage für die Erstellung der
											interessenbezogenen Werbeanzeigen bildet, setzt Google
											Cookies ein. Be-suchen Sie nach dem Setzen des
											Display-Cookies andere Webseite im Google
											Display-Netzwerk, werden Ihnen Werbeeinblendungen
											angezeigt, die mit hoher Wahrscheinlichkeit zuvor
											aufgerufene Produkt- und Informationsbereiche
											berücksichtigen. Sie können die Verwendung des Cookies
											durch Google dauerhaft deaktivieren, indem Sie dem
											nachfolgenden Link folgen und das dort bereitgestellte
											Plug-In herunterladen und installieren:{" "}
											<a
												href="https://www.google.com/settings/ads/plugin"
												target="_blank"
												rel="noopener noreferrer"
											>
												https://www.google.com/settings/ads/plugin
											</a>{" "}
											. Alternativ können Sie die Verwendung von Cookies durch
											Drittanbieter deaktivieren, indem sie die
											Deaktivierungsseite der Netzwerkwerbeinitiative (Network
											Advertising Initiative) unter{" "}
											<a
												href="http://www.networkadvertising.org/choices/"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.networkadvertising.org/choices/
											</a>{" "}
											aufrufen und die dort genannten weiterführenden
											Information zum Opt-Out umsetzen. Weiterführende
											Informationen zu Google Remarketing sowie die
											Datenschutzerklärung von Google können Sie einsehen
											unter:{" "}
											<a
												href="http://www.google.com/privacy/ads/"
												target="_blank"
												rel="noopener noreferrer"
											>
												http://www.google.com/privacy/ads/
											</a>
											.
										</p>
										<Box my={3} id="verwendung-von-facebook-plugins">
											<strong>Verwendung von Facebook-Plugins</strong>
										</Box>
										<p>
											Auf diesen Internetseiten werden Plugins des sozialen
											Netzwerkes facebook.com verwendet, das von der Facebook
											Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA
											betrieben wird (&quot;Facebook&quot;).
											<br /> Wenn Sie mit einem solchen Plugin versehene
											Internetseiten unserer Internetpräsenz aufrufen, wird
											eine Verbindung zu den Facebook-Servern hergestellt und
											dabei das Plugin durch Mitteilung an Ihren Browser auf
											der Internetseite dargestellt. Hierdurch wird an den
											Facebook-Server übermittelt, welche unserer
											Internetseiten Sie besucht haben. Sind Sie dabei als
											Mitglied bei Facebook eingeloggt, ordnet Facebook diese
											Information Ihrem persönlichen Facebook-Benutzerkonto
											zu. Bei der Nutzung der Plugin-Funktionen (z.B.
											Anklicken des „Gefällt mir“-Buttons, Abgabe eines
											Kommentars) werden auch diese Informationen Ihrem
											Facebook-Konto zugeordnet, was Sie nur durch Ausloggen
											vor Nutzung des Plugins verhindern können. <br />
											Wenn Sie nicht möchten, dass Facebook die gesammelten
											Informationen unmittelbar Ihrem Facebook Profil
											zuordnet, müssen Sie sich entweder vor dem Besuch
											unserer Seite bei Facebook ausloggen oder Sie nutzen das
											von Facebook zur Verfügung gestellte Add-On für Ihren
											Browser webgraph facebookblocker. Hierdurch können Sie
											das Laden der Facebook Plugins blockieren. Nähere
											Informationen zur Erhebung und Nutzung der Daten durch
											Facebook, über Ihre diesbezüglichen Rechte und
											Möglichkeiten zum Schutz Ihrer Privatsphäre finden Sie
											in den Datenschutzhinweisen von Facebook.
										</p>
										<Box
											my={3}
											id="auskunft-berichtung-sperrung-und-loeschung-von-daten"
										>
											<strong>
												Auskunft, Berichtigung, Sperrung und Löschung von
												Daten
											</strong>
										</Box>
										<p>
											Sie haben jederzeit das Recht auf unentgeltliche
											Auskunft über Ihre gespeicherten Daten sowie das Recht
											auf Berichtigung, Löschung bzw. Sperrung. Kontaktieren
											Sie uns auf Wunsch. Die Kontaktdaten finden Sie in
											unserem Impressum.
										</p>
										<Box my={3} id="einbindung-des-trusted-shops-trustbadge">
											<strong>Einbindung des Trusted Shops Trustbadge</strong>
										</Box>
										<p>
											Zur Anzeige unseres Trusted Shops Gütesiegels und der
											gegebenenfalls gesammelten Bewertungen sowie zum Angebot
											der Trusted Shops Produkte für Käufer nach einer
											Bestellung ist auf dieser Webseite das Trusted Shops
											Trustbadge eingebunden.
										</p>
										<p>
											Dies dient der Wahrung unserer im Rahmen einer
											Interessensabwägung überwiegenden berechtigten
											Interessen an einer optimalen Vermarktung unseres
											Angebots gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO. Das
											Trustbadge und die damit beworbenen Dienste sind ein
											Angebot der Trusted Shops GmbH, Subbelrather Str. 15C,
											50823 Köln.
										</p>
										<p>
											Bei dem Aufruf des Trustbadge speichert der Webserver
											automatisch ein sogenanntes Server-Logfile, das z.B.
											Ihre IP-Adresse, Datum und Uhrzeit des Abrufs,
											übertragene Datenmenge und den anfragenden Provider
											(Zugriffsdaten) enthält und den Abruf dokumentiert.
											Diese Zugriffsdaten werden nicht ausgewertet und
											spätestens sieben Tagen nach Ende Ihres Seitenbesuchs
											automatisch überschrieben.
										</p>
										<p>
											Weitere personenbezogene Daten werden lediglich an
											Trusted Shops übertragen, soweit Sie hierzu eingewilligt
											haben, sich nach Abschluss einer Bestellung für die
											Nutzung von Trusted Shops Produkten entscheiden oder
											sich bereits für die Nutzung registriert haben. In
											diesem Fall gilt die zwischen Ihnen und Trusted Shops
											getroffene vertragliche Vereinbarung.
										</p>
										<p>
											Weitere personenbezogene Daten werden lediglich an
											Trusted Shops übertragen, soweit Sie hierzu eingewilligt
											haben, sich nach Abschluss einer Bestellung für die
											Nutzung von Trusted Shops Produkten entscheiden oder
											sich bereits für die Nutzung registriert haben. In
											diesem Fall gilt die zwischen Ihnen und Trusted Shops
											getroffene vertragliche Vereinbarung.
										</p>
										<p>Letzte Aktualisierung: 24.1.2023</p>
									</Box>
								</Grid>
							</Grid>
						</Box>
					</Container>
				</Box>
			</div>
		</>
	)
}

export default ImprintPage
